import _ from 'lodash';
import appConfig from '@nerdwallet/app-config';
import createOfferSdk from '@nerdwallet/nw-api-sdk/offers';
import createMarketplaceSdk from '@nerdwallet/nw-api-sdk/marketplace';
import createNwApiSdk from '@nerdwallet/nw-api-sdk';
import { Experiment } from './experiment-list';

const nwApiSDK = createNwApiSdk({
  applicationID: 'nerdWallet web',
  clientID: appConfig.CLIENT_ID || 'landing-page-client',
  cookieDomain: appConfig.COOKIE_DOMAIN,
  identityBaseUrl: appConfig.IDENTITY_BASE_URL,
  abUrl: appConfig.AB_BASE_URL,
  abExperimentList: _.map(Experiment, (exp) => exp.id),
  xhrTimeout: 10000,
});

nwApiSDK.IdentityProfilesToInclude = [
  nwApiSDK.IdentitySDK.PROFILES.GLOBAL_PROFILE,
  nwApiSDK.IdentitySDK.PROFILES.TU_CREDIT_REPORT_PROFILE,
];

export const marketplaceSDK = createMarketplaceSdk({
  ServiceSDK: nwApiSDK.ServiceSDK,
  clientID: appConfig.CLIENT_ID,
  marketplaceBaseUrl: appConfig.MARKETPLACE_API_BASE_URL,
  wpApiBaseUrl: appConfig.API.BASE_URLS.WP_API,
});

export const OfferSDK = createOfferSdk({
  ServiceSDK: nwApiSDK.ServiceSDK,
  clientID: appConfig.CLIENT_ID,
  offerBaseUrl: appConfig.MARKETPLACE_API_BASE_URL,
  version: 1,
});

export default nwApiSDK;
